// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/NewPoll/index.css
// module id = 2353
// module chunks = 0